/**
 * Section color system — a restrained teal/blue family (Apple Health / Linear
 * restraint): every nav tab and its dashboard room uses a tint or shade of
 * the same two families plus neutrals, never competing pastels.
 * accent = icons/text/buttons · deep = hover/text-on-tint · soft = 5–8% wash.
 */
export const SECTION_COLORS = {
    home:        { accent: "#12776F", deep: "#0C3E4B", soft: "#EDF4F5" }, // primary teal
    roadmap:     { accent: "#1D8A85", deep: "#256664", soft: "#EDF5F4" }, // medium teal
    askLane:     { accent: "#3D5A80", deep: "#334C6C", soft: "#EFF3F8" }, // primary blue
    learn:       { accent: "#4F7F95", deep: "#4E6D89", soft: "#F0F5F9" }, // medium blue
    resources:   { accent: "#6E8387", deep: "#5D7074", soft: "#F1F4F4" }, // gray-teal neutral
    guide:       { accent: "#34506F", deep: "#2B435D", soft: "#EEF2F7" }, // deep navy blue
    wellness:    { accent: "#1D8A85", deep: "#427977", soft: "#EEF6F5" }, // soft teal
    careSummary: { accent: "#64748B", deep: "#556377", soft: "#F1F3F6" }, // gray-blue neutral
};
